<style lang="scss" scoped>
.gifts-row {
    display: flex;
    flex-flow: wrap;
    margin: 0 -12px;
    .gift-card {
        padding: 0 12px;
        flex-grow: 1;
        flex: none;
    }
}
::v-deep .tns-ovh {
    overflow: visible;

    .tns-inner {
        @media screen and (max-width: 1279.98px) {
            overflow: scroll !important;
            margin-right: -160px !important;
            margin-left: -160px !important;
            padding-left: 160px !important;

            .tns-slider {
                > div:last-child {
                    margin-right: 144px !important;
                }
            }

            ::-webkit-scrollbar {
                display: none; /* Chrome Safari */
            }
            scrollbar-width: none; /* Firefox */
            -ms-overflow-style: none; /* IE 10+ */
        }

        @media screen and (max-width: 575.98px) {
            margin-right: -24px !important;
            margin-left: -24px !important;
            padding-left: 24px !important;


            .tns-slider {
                > div:last-child {
                    margin-right: 8px !important;
                }
            }
        }
    }
}
</style>

<template>
    <div class="container">
        <div class="row" v-if="!$root.isMobile">
            <div class="col-12">
                <div v-if="title" class="mb-40 d-flex flex-wrap w-100">
                    <h3 v-if="title" v-html="title" class="title"></h3>
                </div>
                <slide-y-down-transition group class="gifts-row" tag="div">
                    <gift-card ref="cards" v-show="show" class="gift-card" :pages="pages" :class="{ 'mb-40' : moreItemsThanPossible }" v-for="(gift, index) in gifts" :key="index" :gift="gift" :style="{ width: `calc(100% / ${(index+1) !== gifts.length ? item_count : lastItemDivision })`}" :ratio="ratio" :fixed-height="(index+1) !== gifts.length ? null : fixedHeight" />
                </slide-y-down-transition>
            </div>
        </div>
        <div v-show="$root.isMobile" class="row">
            <div class="col-12">
                <h3 v-html="title" class="title mb-32"></h3>
                <div class="w-100" ref="sliderParent">
                    <div class="gift-slider" ref="slider">
                        <gift-card v-for="(gift, index) in gifts" :pages="pages" :key="index" class="gift-card" :class="{ 'mb-40' : moreItemsThanPossible }" :gift="gift" :ratio="mobileRatio" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import row from "../mixins/row";
import mobileSlider from "../mixins/mobile-slider";
import { tns } from "tiny-slider/src/tiny-slider.module"
import { SlideYDownTransition } from 'vue2-transitions'

export default {
    name: "pagePart.gifts-row",

    mixins: [row, mobileSlider],

    components: { SlideYDownTransition },

    props: {
        itemsPerRow: {
            type: Number,
            default: null,
        },
        gifts: {
            type: Array,
            required: true,
            default: () => {
                return [];
            },
        },
        pages: {
            type: Array,
            required: false,
            default: null
        },
    },

    data: (vm) => ({
        show: false,
        fixedHeight: null,
        oldWidth: document.documentElement.clientWidth,

    }),

    mounted() {
        var self = this;
        this.show = true;
        this.getFixedHeight();

        window.addEventListener('resize', () => { // only on width change because URL bar resizing on mobile         
            var newWidth = document.documentElement.clientWidth;
            if (newWidth != self.oldWidth) {
                self.getFixedHeight()
            }
            self.oldWidth = newWidth;
        });

        window.addEventListener('orientationchange', this.getFixedHeight)
    },

    methods: {
        getFixedHeight() {
            this.$nextTick(() => {
                if (this.$root.isMobile) {
                    return
                }
                this.$nextTick(() => {
                    if (this.$refs.cards.length) {
                        let imageCard = this.$refs.cards.find(card => card.$refs.primary !== undefined);
                        if (imageCard) {
                            this.fixedHeight = imageCard.$refs.primary.clientHeight
                        }
                    }
                })
            })
        }
    },

    computed: {
        item_count() {
            if (this.itemsPerRow) return this.itemsPerRow
            if (this.gifts.length > 5) return 6;
            return this.gifts.length
        },
        lastItemDivision() {
            const index = this.gifts.length
            if (index % this.item_count === 0) return this.item_count

            return 100 / ((this.item_count - (index % this.item_count - 1)) / this.item_count * 100)
        },
        moreItemsThanPossible() {
            return this.gifts.length > this.itemsPerRow;
        }
    }
}
</script>